import React from 'react';
import { Grid } from '@mui/material';
import BreadCrumbs from '../Common/BreadCrumbs';
import TopLeakRates from './TopLeakRates';
import UnderRepairSystems from './UnderRepairSystems';
import PageTitleWithToolTip from '../Common/PageTitleWithTooltip';
import AssetsDueForInspection from './AssetsDueForInspection';
import CriticalIssues from './CriticalIssues';
import UserInfo from '../../UserInfo';
import './Dashboard.css';
import useBreadCrumbs from '../../hooks/useBreadCrumbs';
import useNavigate from '../../hooks/useNavigate';
import AssetByApplicableRegulation from './AssetByApplicableRegulation';

const ComplianceCenter = ({
    history
}) => {
    useNavigate({
        pageName: 'ComplianceCenter'
    });
    useBreadCrumbs({
        path: { id: 'ComplianceCenter', text: 'Compliance Center', link: history.location.pathname, reset: true }
    });

    return (
        <>
            <BreadCrumbs
                path={[
                    { text: 'Compliance Center' }
                ]}
            />
            <Grid
                container
                direction="row"
                alignItems="center"
            >
                <Grid item xs={12} md={12} lg={12}>
                    <div className='complianceCenterDemo'>
                        <PageTitleWithToolTip
                            pageTitle="Compliance Center"
                            toolTipText="Use the compliance center to stay up to date on the impact from your maintenance work and to assist in compliance management."
                        />
                    </div>
                </Grid>

                {(!UserInfo.isServiceProvider() && (UserInfo.isReadOnly() || UserInfo.isSystemAdministrator() || UserInfo.isSuperTenantAdmin() || UserInfo.isTenantAdministrator() || UserInfo.isRegionalAdministrator())) && (
                    <>
                        <Grid item xs={12}>
                            <AssetByApplicableRegulation />
                        </Grid>
                        <Grid item xs={12} mt={2}>
                            <TopLeakRates />
                        </Grid>
                        <Grid item xs={12} mt={2}>
                            <AssetsDueForInspection />
                        </Grid>
                        <Grid item xs={12} mt={2}>
                            <UnderRepairSystems />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <CriticalIssues />
                        </Grid>
                    </>
                )}

            </Grid>
        </>
    );
}

export default ComplianceCenter;
